import { motion, useReducedMotion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({
  children,
  delay = 0,
  y = 32,
  className = "",
  duration = 0.9,
}) => {
  const reduce = useReducedMotion();
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y: reduce ? 0 : y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration, delay, ease: EASE }}
    >
      {children}
    </motion.div>
  );
};

export const Eyebrow = ({ children, light = false }) => (
  <p
    className={`font-mont text-sm font-bold uppercase tracking-[0.28em] ${
      light ? "text-stone" : "text-white/45"
    }`}
  >
    {children}
  </p>
);

export const Check = ({ className = "" }) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    aria-hidden="true"
    className={`shrink-0 ${className}`}
  >
    <path
      d="M2 7.5L5.5 11L12 3"
      stroke="#1F4D3A"
      strokeWidth="1.8"
      strokeLinecap="square"
    />
  </svg>
);

export default Reveal;
